import { render, staticRenderFns } from "./formTaxes.vue?vue&type=template&id=3c0c4d91&scoped=true"
import script from "./formTaxes.vue?vue&type=script&lang=js"
export * from "./formTaxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c4d91",
  null
  
)

export default component.exports